import { ReactNode } from "react";

export interface ICol {
  children: ReactNode;
  className?: string;
}

function Col({ children, className }: ICol) {
  return <div className={`col ${className}`}>{children}</div>;
}
export default Col;
